<template>
  <b-row :class="`${styleClassRow} align-items-center`">
    <b-form-checkbox
      v-if="checkbox"
      :id="id"
      v-model="addExtra"
    >
      Add Another
    </b-form-checkbox>

    <submit-button
      :title="buttonText"
      @submit="$emit('submit', addExtra)"
      vfg
    />
  </b-row>
</template>

<script>

import SubmitButton from '@/components/utils/buttons/form/SubmitButton';

export default {
  components: {
    SubmitButton,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    checkbox: {
      type: Boolean,
      default: true,
    },
    buttonText: {
      type: String,
      default: 'Add Asset',
    },
    styleClassRow: String,
  },
  data() {
    return {
      addExtra: false,
    };
  },
};

</script>



// WEBPACK FOOTER //
// src/components/utils/buttons/misc/AddAssetButton.vue